import React, { useEffect, useState } from "react";
import TopVeiwForDashBoard from "../CommonComponents/TopVeiwForDashBoard";
// import "./style.css";
import moment from "moment";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import { isArray } from "lodash";
// import { Styles } from "../FuelReports/FuelCalibrationReports/style";
import { Styles } from "./style";

import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import FilterTemplate from "../CommonComponents/SidebarDrawer/FilterTemplate";
import { SiteAction } from "../../actions/site";
import { VehicleAction } from "../../actions/vehicle";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100%",
    // marginTop: "7rem",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
    background: "#FFF",
    padding: "5px",
    marginTop: "10px",
  },
  tableConatiner: {
    maxHeight: "62vh",
    overflow: "scroll",
  },
  table: {
    maxHeight: 30,
    height: "100%", // Add this line or adjust as needed
  },

  stickyHeader: {
    position: "sticky",
    top: 0,
    background: "rgb(37 214 234 / 87%)",
    fontWeight: "bold",
    color: "#fff",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    position: "sticky",
    top: "0",
    background: "rgb(32 80 130)",
    fontWeight: "bold",
    color: "#fff",
  },
  body: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}))(TableCell);

function CheckDropList({  data, reportType }) {
  const classes = useStyles();

  const [header, setHeader] = useState([
    {
      id: "0",
      name: "S.No",
      keyName: "Sno",
      show: true,
      isDate: false,
      srNo: null,
      alignment: "text-center",
      hyper: false,
    },
    {
      id: "1",
      name: "Vehicle No",
      keyName: "vehicleDetails",
      show: true,
      isDate: false,
      srNo: null,
      alignment: "text-center",
      hyper: false,
    },
    {
      id: "2",
      name: "Date & Time",
      keyName: "stoppageInfo",
      show: true,
      isDate: true,
      srNo: null,
      alignment: "text-center",
      hyper: true,
    },
    // {
    //   id: "3",
    //   name: "Address",
    //   keyName: "address",
    //   show: true,
    //   isDate: false,
    //   srNo: null,
    //   alignment: "text-center",
    //   hyper: false,
    // },
    {
      id: "5",
      name: "Area",
      keyName: "area",
      show: true,
      isDate: false,
      srNo: null,
      alignment: "text-center",
      hyper: false,
    },
    {
      id: "6",
      name: "Before ",
      keyName: "intialEventFuel",
      show: true,
      isDate: false,
      srNo: null,
      alignment: "text-left",
      hyper: false,
    },
    // {
    //   id: "7",
    //   name: "Droppage(Ltr.)",
    //   keyName: "fuelInLiter",
    //   show: true,
    //   isDate: false,
    //   srNo: null,
    //   alignment: "text-left",
    //   hyper: false,
    // },
    {
      id: "8",
      name: "After",
      keyName: "afterEventFuel",
      show: true,
      isDate: false,
      srNo: null,
      alignment: "text-left",
      hyper: false,
    },
    {
      id: "0",
      name: "RowType",
      keyName: "fuelType",
      show: true,
      isDate: false,
      srNo: null,
      alignment: "Row Type",
      hyper: false,
    }
    // {
    //   id: "9",
    //   name: "Remarks Action",
    //   keyName: "remarksAction",
    //   show: true,
    //   isDate: false,
    //   srNo: null,
    //   alignment: "text-left",
    //   hyper: false,
    // },
  ]);
  return (
    <div className="">
      <Paper>
        <Grid>
          <TableContainer className={classes.tableConatiner}>
            <table
              className="w-100"
              aria-labelledby="tableTitle"
              aria-label="enhanced table"
              // style={{
              //   boxShadow:
              //     "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
              // }}
              // stickyHeader aria-label="sticky table"
            >
              <TableHead>
                <TableRow className="theadbg border">
                  {header &&
                    header.length > 0 &&
                    header.map((head, i) =>
                      head.show === true ? (
                        <StyledTableCell
                          style={{
                            minWidth: head.minWidth,
                            zIndex: "100",
                            lineHeight: "1.5rem",
                            padding: "16px",
                            letterSpacing: "0.01071em",
                            fontWeight: "600",
                            // backgroundColor: "rgb(233, 241, 241)",
                          }}
                          key={i}
                        >
                          {head.name}
                        </StyledTableCell>
                      ) : (
                        ""
                      )
                    )}
                </TableRow>
              </TableHead>

              <TableBody className="border">
                {data.map((val, index) => {
                  return (
                    <>
                      <TableRow
                        style={{
                          backgroundColor:
                          val.backgroundColor?val.backgroundColor:
                            (reportType === "FUELFILL" ||
                              reportType === "CONSUMPTION") &&
                            val?.isFuelWireCut == true
                              ? "rgb(52 58 64 / 47%)"
                              : val?.fuelFillIssueVerification == "CONFIRMED" &&
                                JSON.parse(localStorage.getItem("data"))
                                  .userType == "ADMIN"
                              ? "rgb(190 235 190)"
                              : reportType === "FUELFILL" &&
                                val?.fuelFillIssueVerification ==
                                  "UNACEPTABLE" &&
                                JSON.parse(localStorage.getItem("data"))
                                  .userType == "ADMIN"
                              ? "#dc3b3580"
                              : reportType === "FUELDROP"
                              ? // val.alertAction.status=="ACTION_TAKEN"?
                                val?.isFuelWireCut
                                ? "rgb(52 58 64 / 47%)"
                                : val?.alertAction?.status === "APPROVED" ||
                                  (val?.alertAction?.status ===
                                    "ACTION_TAKEN" &&
                                    val?.lastAlertAction?.status === "APPROVED")
                                ? "rgb(194, 255, 208)"
                                : ""
                              : reportType == "FUELFILLDROPCOMBINEDREPORT"
                              ? val?.tFuelFill
                                ? "rgb(78, 199, 106)"
                                : // : val.tFuelDropage
                                val?.tFuelDropage
                                ? "rgb(199, 53, 26)"
                                : ""
                              : "",
                          zIndex: reportType == "FUELDROP" ? 2 : "",
                        }}
                      >
                        {header &&
                          header.map((headerName) => {
                            return (
                              <>
                                {headerName.keyName == "Sno" ? (
                                  <StyledTableCell>{index + 1}</StyledTableCell>
                                ) : headerName.isDate == true ? (
                                  <StyledTableCell>
                                    {val[headerName.keyName]
                                      ? moment(val[headerName.keyName]).add("05:30:00").format(
                                          "YYYY-MM-DD HH:mm a"
                                        )
                                      : ""}
                                  </StyledTableCell>
                                ) : (
                                  <StyledTableCell>
                                    {val[headerName?.keyName]}
                                  </StyledTableCell>
                                )}
                              </>
                            );
                          })}
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </table>
          </TableContainer>
        </Grid>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
          component="div"
          count={totalPages}
          rowsPerPage={pageSize}
          page={pageNo}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        /> */}
      </Paper>
    </div>
  );
}

export default CheckDropList;
